import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FlowsService } from "src/app/flows/flows.service";
import { FlowMenuComponent } from "../../flow-menu/flow-menu.component";
import { find, filter, extend } from "lodash";
import { IntegrationsService } from "src/app/integrations/integrations.service";
import {
  debounceTime,
  startWith,
  switchMap,
  takeUntil,
} from "rxjs/operators";

export interface EMailPayloadProperty {
  keyNamePrefix: string;
  keyControl: FormControl;
  valueControl: FormControl;
  completed: boolean;
}

@Component({
  selector: "app-email-node-menu",
  templateUrl: "./email-node-menu.component.html",
  styleUrls: ["./email-node-menu.component.scss"],
})
export class EMailNodeMenuComponent
  extends FlowMenuComponent
  implements OnInit
{
  emailNodeForm!: FormGroup;
  integrationOptions: any;
  integration?: any;
  templateOptions: any;
  template?: any;
  subject?: string;
  payloadProperties?: EMailPayloadProperty[];
  frequencyOptions!: any[];
  frequency?: any;

  constructor(
    private FlowsService: FlowsService,
    private IntegrationService: IntegrationsService,
  ) {
    super();
  }

  ngOnInit(): void {
    //console.log('EMAIL-NODE-MENU INIT')

    super.ngOnInit();

    this.frequencyOptions = this.FlowsService.getFrequencies('email');

    this.integrationOptions = filter(this.FlowsService.integrationOptions, (i) => {
      return i.provider.type == 'email';
    }).map((o)=>{
      o.name = o.provider.name;
      return o;
    });

    if(this.node.data?.integration_id){
      this.integration = find(this.integrationOptions, {id: this.node.data?.integration_id});
      this.getTemplates();
    }

    if(this.node.data?.subject){
      this.subject = this.node.data?.subject;
    }

    if(this.node.data?.frequency){
      this.frequency = this.node.data?.frequency;
    }

    //
    
    this.payloadProperties = [];
    if (this.node.data.payload) {
      for (let payloadKey of Object.keys(this.node.data.payload)) {
        this.payloadProperties.push({
          keyControl: new FormControl({ value: payloadKey, disabled: true }, [
            Validators.required,
          ]),
          valueControl: new FormControl(
            {
              value: this.node.data.payload[payloadKey],
              disabled: true,
            },
            [Validators.required],
          ),
          completed: true,
          keyNamePrefix: "Enter",
        });
      }
    }
    this.pushNewPayloadProperty();

    //

    this.emailNodeForm = new FormGroup({
      integration: new FormControl(this.integration, [Validators.required]),
      template: new FormControl({value: this.template, disabled: true}, [Validators.required]),
      subject: new FormControl({value: this.subject, disabled: true}, [Validators.required]),
      frequency: new FormControl(this.frequency, [Validators.required]),
    });

    this.emailNodeForm.get("integration")?.valueChanges.subscribe(val => {
      this.integration = find(this.integrationOptions, {id: val.id});
      this.getTemplates();
    });
   
  }

  getTemplates() {
    this.IntegrationService.getEmailTemplates(this.integration.provider.provider, this.integration.id).subscribe(opts => {
      this.templateOptions = opts;
      if(this.node.data?.template_id){
        this.template = find(this.templateOptions, {id: this.node.data?.template_id});
        this.emailNodeForm.patchValue({
          template: this.template
        });
      }
      this.emailNodeForm.get("template")?.enable();
      this.emailNodeForm.get("subject")?.enable();
    })
  }

  addPayloadProperty(currentProperty: EMailPayloadProperty) {
    currentProperty.completed = true;
    currentProperty.keyControl.disable();
    currentProperty.valueControl.disable();
    this.pushNewPayloadProperty();
  }

  removePayloadProperty(currentProperty: EMailPayloadProperty) {
    this.payloadProperties = this.payloadProperties!.filter(
      (property) => property !== currentProperty,
    );
  }

  pushNewPayloadProperty() {
    const payLoadProperty: EMailPayloadProperty = {
      keyControl: new FormControl("", [Validators.required]),
      valueControl: new FormControl("", [Validators.required]),
      completed: false,
      keyNamePrefix: "Enter",
    };
    this.payloadProperties!.push(payLoadProperty);
  }

  get integrationSet() {
    return this.integration != null;
  }

  get invalid() {
    return !this.emailNodeForm?.valid;
  }

  get emailFrequencies() {
    return this.frequencyOptions;
  }

  get nodeDTO() {
    return {
      id: this.node.id,
      type: "email",
      top: this.node.top,
      left: this.node.left,
      is_follow_up: this.node.is_follow_up,
      data: {
        type: "email",
        integration_id: this.emailNodeForm.get("integration")?.value.id,
        template_id: this.emailNodeForm.get("template")?.value.id,
        subject: this.emailNodeForm.get("subject")?.value,
        payload: this.payloadDTO,
        frequency: this.emailNodeForm.get("frequency")?.value,
      },
    };
  }

  get payloadDTO() {
    const obj: any = {};

    const completedProperties = this.payloadProperties!.filter(
      (property) => property.completed,
    );

    for (let property of completedProperties) {
      obj[property.keyControl.value] = property.valueControl.value;
    }

    return obj;
  }

  get showPayload() {
    if(this.payloadProperties == undefined){
      return false
    }
    if(this.payloadProperties!.filter(
      (property) => property.completed,
    ).length == 0){
      return false
    }
    return true
  }

  get payloadPreview() {
    const obj: any = {
    };
    const now = new Date()
    if(this.internal){
      extend(obj, {
        lhpe_account: {
          name: "Account Name",
          user_count: 10,
          flow_count: 1,
          broadcast_count: 0,
          geofence_count: 2,
          beacon_region_count: 0,
          created_at: new Date(now.getFullYear(), now.getMonth(), now.getDay())
        },
        lhpe_user: {
          first_name: "George",
          last_name: "Jones",
          name: "George Jones",
          email: "george.jones@clientdomain.com"
        },
        lhpe_flow: {
          name: "Flow Title",
          created_at: new Date(now.getFullYear(), now.getMonth(), now.getDay())
        },
        lhpe_broadcast: {
          name: "Broadcast Title",
          created_at: new Date(now.getFullYear(), now.getMonth(), now.getDay())
        }
      }, this.payloadDTO)
    } else {
      extend(obj, {
        lhpe_user: {
          created_at: new Date(now.getFullYear(), now.getMonth(), now.getDay()),
          first_name: "Luke",
          last_name: "Skywalker",
          name: "Luke Skywalker",
          email: "luke.skywalker@rebels.org",
          company: "Rebel Alliance",
          date_of_birth: new Date(1977, 4, 25),
          profile: {
            strength: 7,
            experience: 4,
            resolve: 10
          }
        }
      }, this.payloadDTO)
    }
    extend(obj, {
      recipient: {
        name: "John Smith",
        email: "john.smith@clientdomain.com"
      },
      subject: this.subject
    })
    return obj;
  }

}
